'use client';

import { c as _c } from "react/compiler-runtime";
import { ScrollArea as ScrollAreaPrimitive } from '@base-ui/react/scroll-area';
import { cn } from '@/utils/cn';
type ScrollAreaProps = ScrollAreaPrimitive.Root.Props;
export function ScrollArea(props) {
  const $ = _c(15);
  let children;
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== className) {
    t0 = cn("relative flex flex-col", className);
    $[4] = className;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== children) {
    t1 = <ScrollAreaPrimitive.Viewport data-slot="scroll-area-viewport" className="grow">{children}</ScrollAreaPrimitive.Viewport>;
    $[6] = children;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ScrollBar />;
    t3 = <ScrollBar orientation="horizontal" />;
    t4 = <ScrollAreaPrimitive.Corner />;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== rest || $[12] !== t0 || $[13] !== t1) {
    t5 = <ScrollAreaPrimitive.Root data-slot="scroll-area" className={t0} {...rest}>{t1}{t2}{t3}{t4}</ScrollAreaPrimitive.Root>;
    $[11] = rest;
    $[12] = t0;
    $[13] = t1;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
type ScrollBarProps = ScrollAreaPrimitive.Scrollbar.Props;
export function ScrollBar(props) {
  const $ = _c(11);
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      className,
      orientation: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const orientation = t0 === undefined ? "vertical" : t0;
  let t1;
  if ($[4] !== className) {
    t1 = cn("pointer-events-none m-2 flex rounded-full bg-neutral-200 opacity-0 transition-opacity data-hovering:pointer-events-auto data-hovering:opacity-100 data-scrolling:pointer-events-auto data-scrolling:opacity-100 data-horizontal:h-1.5 data-vertical:w-1.5", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ScrollAreaPrimitive.Thumb data-slot="scroll-area-thumb" className="w-full rounded-full bg-neutral-400" />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== orientation || $[8] !== rest || $[9] !== t1) {
    t3 = <ScrollAreaPrimitive.Scrollbar data-slot="scroll-area-scrollbar" data-orientation={orientation} orientation={orientation} className={t1} {...rest}>{t2}</ScrollAreaPrimitive.Scrollbar>;
    $[7] = orientation;
    $[8] = rest;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}